const DUMMY_HINTS = {
  SELL_CURRENCY: 'sellCurrencyInput',
  COMMISSION: 'commissionInput',
  WALLET_ADDRESS_NETWORK: 'walletAddressNetworkInput',
  REQUEST_ID: 'requestIDInput',
  ATM_NUMBER: 'atmNumberInput',
  PIN_CODE: 'pinCodeInput',
  DATE: 'DateInput',
  BUY_CURRENCY: 'buyCurrencyInput',
  DEAL_RATE: 'dealRateInput',
  ENTERED_AMOUNT: 'EnteredAmountInput',
  RECEIVED_AMOUNT: 'receivedAmountInput',
  COMMISSION_NETWORK: 'commissionNetworkInput',
  CRYPTOCURRENCY_RECEIVING_ADDRESS: 'cryptocurrencyReceivingAddressInput',
};

const DUMMY_HINTS_LIST = [
  {
    caption: 'Sell currency',
    name: DUMMY_HINTS.SELL_CURRENCY,
  },
  {
    caption: 'Commission',
    name: DUMMY_HINTS.COMMISSION,
  },
  {
    caption: 'Address network',
    name: DUMMY_HINTS.WALLET_ADDRESS_NETWORK,
  },
  {
    caption: 'Request ID',
    name: DUMMY_HINTS.REQUEST_ID,
  },
  {
    caption: 'ATM number',
    name: DUMMY_HINTS.ATM_NUMBER,
  },
  {
    caption: 'PIN code',
    name: DUMMY_HINTS.PIN_CODE,
  },
  {
    caption: 'Date',
    name: DUMMY_HINTS.DATE,
  },
  {
    caption: 'Buy currency',
    name: DUMMY_HINTS.BUY_CURRENCY,
  },
  {
    caption: 'Deal rate',
    name: DUMMY_HINTS.DEAL_RATE,
  },
  {
    caption: 'Entered amount',
    name: DUMMY_HINTS.ENTERED_AMOUNT,
  },
  {
    caption: 'Received amount',
    name: DUMMY_HINTS.RECEIVED_AMOUNT,
  },
  {
    caption: 'Commission network',
    name: DUMMY_HINTS.COMMISSION_NETWORK,
  },
  {
    caption: 'Receiving address',
    name: DUMMY_HINTS.CRYPTOCURRENCY_RECEIVING_ADDRESS,
  },
];

export default {
  DUMMY_HINTS,
  DUMMY_HINTS_LIST,
};
